// dependecies import ==>
import React, { useEffect, useState } from "react";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
// assets and scss import ==>
import "./footerPagination.scss";
// project file import ==>
// constant import ==>

const FooterPagination = (props) => {
  const { totalCount, currentPage, pageSize, hideShowRecords, onPageChange } =
    props;

  const pageCount = Math.ceil(+totalCount / +pageSize);
  const totalPageSize = pageSize ? +pageSize : 10;

  const [currentMinLimit, setCurrentMinLimit] = useState(1);
  const [currentMaxLimit, setCurrentMaxLimit] = useState(totalPageSize);

  // Life cycle methods ===>

  useEffect(() => {
    if (currentPage) {
      let num = +currentPage % totalPageSize;
      let minLimit = +currentPage - (num === 0 ? totalPageSize - 1 : num - 1);
      let maxLimit =
        minLimit + (totalPageSize - 1) > pageCount
          ? pageCount
          : minLimit + (totalPageSize - 1);
      setCurrentMinLimit(minLimit);
      setCurrentMaxLimit(maxLimit);
      handleOnClick(currentPage, minLimit, maxLimit);
    }
  }, [currentPage, pageCount]);

  // <===

  // Actions ===>

  const handleOnClick = (index, minLimit, maxLimit) => {
    if (+index < minLimit) {
      setCurrentMinLimit(minLimit - totalPageSize);
      setCurrentMaxLimit(minLimit - 1);
    }
    if (maxLimit + 1 === +index && +index !== pageCount) {
      if (maxLimit + 1 <= pageCount) {
        setCurrentMinLimit(maxLimit + 1);
      }
      if (maxLimit + totalPageSize <= pageCount) {
        setCurrentMaxLimit(maxLimit + totalPageSize);
      } else {
        setCurrentMaxLimit(pageCount);
      }
    }
  };

  // <===

  // Display UI ===>

  const renderPagination = () => {
    let list = [];
    if (+currentPage !== 1) {
      list.push(
        <li className="footer-pagination-item">
          <span
            className="footer-pagination-link footer-pagination-link-text footer-pagination-arrows"
            aria-label="Previous"
            onClick={() => onPageChange(+currentPage - 1)}
          >
            <KeyboardArrowLeftIcon fontSize="small" />
          </span>
        </li>
      );
    }
    for (
      let page = currentMinLimit;
      page <= (pageCount > totalPageSize ? currentMaxLimit : pageCount);
      page++
    ) {
      const active = page === +currentPage ? "active" : "";
      list.push(
        <li className={`footer-pagination-item ${active}`}>
          <span
            className="footer-pagination-link"
            onClick={() => onPageChange(page)}
          >
            {page}
          </span>
        </li>
      );
    }
    if (+currentPage !== pageCount) {
      list.push(
        <li className="footer-pagination-item">
          <span
            className="footer-pagination-link footer-pagination-link-text footer-pagination-arrows"
            aria-label="Next"
            onClick={() => onPageChange(+currentPage + 1)}
          >
            <KeyboardArrowRightIcon fontSize="small" />
          </span>
        </li>
      );
    }
    return list;
  };

  const getTotalRecordsMessage = () => {
    let page = +pageSize ? +pageSize : totalPageSize;
    var startItem = (+currentPage - 1) * page + 1;
    var endItem = Math.min(+currentPage * page, +totalCount);
    return (
      <span className="footer-pagination-text">{`Showing ${startItem} To ${endItem} Of ${totalCount} Entries`}</span>
    );
  };

  // <===

  return (
    <div className="footer-pagination">
      {+totalCount && +totalCount !== 0 && !hideShowRecords && (
        <div className="footer-pagination-show-records">
          {getTotalRecordsMessage()}
        </div>
      )}
      <ul className="footer-pagination-ui">{renderPagination()}</ul>
    </div>
  );
};

export default FooterPagination;
